import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'pending-changes',
  template: '',
  standalone: false,
})
export class PendingChanges {
  @Output() hasPendingChanges = new EventEmitter<boolean>();
  @Output() hasFooterPendingChanges = new EventEmitter<boolean>();

  emitPendingChanges(pendingChanges: boolean): void {
    this.hasPendingChanges.emit(pendingChanges);
  }

  emitFooterPendingChanges(pendingChanges: boolean): void {
    this.hasFooterPendingChanges.emit(pendingChanges);
  }
}
